/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_OptionInputs */

const en_us2_swap_option = /** @type {(inputs: Swap_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Option`)
};

const pt_br2_swap_option = /** @type {(inputs: Swap_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opção`)
};

const es_419_swap_option = /** @type {(inputs: Swap_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opción`)
};

const pt_pt2_swap_option = /** @type {(inputs: Swap_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opção`)
};

const fr_fr2_swap_option = /** @type {(inputs: Swap_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Option`)
};

const de_de2_swap_option = /** @type {(inputs: Swap_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Option`)
};

const it_it2_swap_option = /** @type {(inputs: Swap_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzione`)
};

/**
* | output |
* | --- |
* | "Option" |
*
* @param {Swap_OptionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_option = /** @type {((inputs?: Swap_OptionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_OptionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_option(inputs)
	if (locale === "es-419") return es_419_swap_option(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_option(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_option(inputs)
	if (locale === "de-DE") return de_de2_swap_option(inputs)
	if (locale === "it-IT") return it_it2_swap_option(inputs)
	return en_us2_swap_option(inputs)
});
export { swap_option as "swap.option" }